import i18next from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { baseURL } from "../Http";
import LanguageDetector from "i18next-browser-languagedetector";
import { getAuthState } from "../autStateHolder";

require("dotenv").config();
const DEFAULT_SYSTEM_LANG = "en";
const { REACT_APP_NOTIFICATION_TEXT = "{}" } = process.env || {};
let tempNotifications = {};
try {
  tempNotifications = JSON.parse(REACT_APP_NOTIFICATION_TEXT) || {};
} catch (err) {
  console.error("Invalid REACT_APP_NOTIFICATION_TEXT config, ignoring:", err);
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    debug: false,
    partialBundledLanguages: true,
    fallbackLng: DEFAULT_SYSTEM_LANG,
    order: ["localStorage", "navigator"],
    caches: ["localStorage", "cookie"],
    react: {
      useSuspense: false,
    },
    // saveMissing: true,
    backend: {
      crossDomain: true,
      loadPath: `${baseURL}/i18n/locales/translations?lng={{lng}}&ns={{ns}}`,
      customHeaders: () => {
        const token = getAuthState()?.accessToken;
        return {
          "subscription-key": process.env.REACT_APP_APIM_SUBSCRIPTION_KEY,
          ...(token && { authorization: `Bearer ${token}` }),
        };
      },
    },
    resources: tempNotifications,
  });
